import React from 'react';
import { modelPlatforms } from '../../data/stack';
import { ModelPlatform } from '../../types/content';
import { CountResult } from '../../utils/api';
import { OPENROUTER_API } from '../../utils/sourceIndex';
import { formatInt } from '../../utils/format';
import { DataBadge } from '../DataBadge';
import { SourceRef } from '../SourceRef';
import { PageSources } from '../PageSources';
const TYPE_STYLE: Record<ModelPlatform['type'], string> = {
  Router: 'border-machine/40 text-machine',
  'Inference cloud': 'border-human/40 text-human',
  'First-party': 'border-line text-muted'
};
export function ModelPlatformsTab({
  openrouter
}: {
  openrouter: CountResult | null;
}) {
  return <section aria-labelledby="model-platforms-title" data-id="element-767" data-mp="2xs6mqnkza7ir">
      <div className="flex flex-wrap items-end justify-between gap-3" data-id="element-768" data-mp="2xsyka3y4yfbo">
        <div data-id="element-769" data-mp="81a4enp608p7">
          <h2 id="model-platforms-title" className="font-serif text-2xl text-ink md:text-3xl" data-id="element-770" data-mp="81tituflweyh">
            Where models are served
          </h2>
          <p className="mt-2 max-w-2xl text-[14px] text-muted" data-id="element-771" data-mp="ho91uyhi2x7m">Routers aggregate many providers behind one API; inference clouds host open models; first-party APIs serve a lab’s own models.</p>
        </div>
      </div>
      <PageSources data-id="element-772" data-mp="8n1fnes9dmtw">
        <DataBadge mode={openrouter ? openrouter.mode : 'loading'} source="OpenRouter · model count" asOf={openrouter?.asOf} data-id="element-773" data-mp="8mj9nqfsnu8s" />
      </PageSources>
      <div className="mt-5 overflow-x-auto rounded-lg border border-line" data-id="element-774" data-mp="3r41nf4gwska">
        <table className="w-full min-w-[1040px] border-collapse text-[13.5px]" data-id="element-775" data-mp="3uwc4ei9tsolo">
          <thead className="bg-surface text-left text-[12px] text-muted" data-id="element-776" data-mp="3q3j2011txscr">
            <tr data-id="element-777" data-mp="3m1xs8okldu6s">
              {['Platform', 'Type', 'Models served', 'Pricing model', 'Notable feature'].map(h => <th key={h} scope="col" className="whitespace-nowrap border-b border-line px-3 py-2.5 font-normal" data-id="element-778" data-mp="3h4xhi0css39c">
                  {h}
                </th>)}
            </tr>
          </thead>
          <tbody data-id="element-779" data-mp="375zyfcy551xq">
            {modelPlatforms.map(p => <tr key={p.name} className="border-b border-line/60 last:border-b-0" data-id="element-780" data-mp="2xhb3bvwqve67">
                <th scope="row" className="whitespace-nowrap px-3 py-3 text-left font-normal text-ink" data-id="element-781" data-mp="32gntoqmtr3dj">
                  {p.name}
                  <SourceRef href={p.sourceUrl} data-id="element-782" data-mp="2oi7j2olucsq4" />
                </th>
                <td className="whitespace-nowrap px-3 py-3" data-id="element-783" data-mp="2sihuigsekbcd">
                  <span className={`rounded border px-1.5 py-0.5 font-mono text-[10.5px] ${TYPE_STYLE[p.type]}`} data-id="element-784" data-mp="2sku70efe5ti1">{p.type}</span>
                </td>
                <td className="px-3 py-3 font-mono text-[12.5px] text-ink" data-id="element-785" data-mp="3l7oor3ktqert">
                  {p.models === 'live' ? <>
                      {openrouter ? formatInt(openrouter.count) : '…'} models
                      <SourceRef href={OPENROUTER_API} data-id="element-786" data-mp="3bgasr5s2zx3f" />
                    </> : <span className={p.models.includes('—') || p.models.startsWith('Not') ? 'text-faint' : ''} data-id="element-787" data-mp="3090j2dd5mcr">{p.models}</span>}
                </td>
                <td className="px-3 py-3 text-muted" data-id="element-788" data-mp="1sifq10v13fx6">{p.pricing}</td>
                <td className="px-3 py-3 text-ink/85" data-id="element-789" data-mp="1sgl4bkbxnjs1">{p.feature}</td>
              </tr>)}
          </tbody>
        </table>
      </div>

    </section>;
}